import { render, staticRenderFns } from "./Rule.vue?vue&type=template&id=36722b1e&scoped=true&"
import script from "./Rule.vue?vue&type=script&lang=ts&"
export * from "./Rule.vue?vue&type=script&lang=ts&"
import style0 from "./Rule.vue?vue&type=style&index=0&id=36722b1e&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36722b1e",
  null
  
)

export default component.exports